// Internals Imports
import { get, put } from "../../api/index";
import { API_ENDPOINTS } from "../../constants";

// Destructuring
const { APIS } = API_ENDPOINTS;

const TOTAL_INBOX_NOTIFICATIONS = 15;

export const fetchInboxNotificationsService = offset =>
  new Promise((resolve, reject) => {
    get(
      `${APIS.GET_NOTIFICATIONS}?count=${TOTAL_INBOX_NOTIFICATIONS}&offset=${offset}`,
    )
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        console.error(
          `inboxServices => fetchInboxNotificationsService => ${error}`,
        );
        reject(error);
      });
  });

export const seenInboxNotificationsService = () =>
  new Promise((resolve, reject) => {
    put(APIS.GET_NOTIFICATIONS)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        console.error(
          `inboxServices => seenInboxNotificationsService => ${error}`,
        );
        reject(error);
      });
  });
